import React from 'react';
import {
  AlertCircle, AlertTriangle, ArrowLeft, ArrowRight, Building2, Check, CheckCircle2,
  ChevronDown, ChevronRight, ExternalLink, FileSpreadsheet, Info, Loader2, Lock, Mail,
  MapPin, Phone, Plus, ShieldCheck, Trash2, Upload, X,
} from 'lucide-react';

/**
 * Thin wrapper over Lucide, keeping one consistent line-icon set.
 *
 * VENDORED CHANGE: the upstream design system loads Lucide from an unpinned
 * unpkg.com <script> and reads window.lucide. That is a supply-chain exposure
 * and a runtime dependency on a third-party CDN, neither of which is acceptable
 * for a production site customers are asked to trust. This version imports the
 * `lucide-react` package instead. The `name` prop contract is unchanged, so it
 * remains a drop-in for the upstream component.
 *
 * Icons are imported explicitly rather than dynamically so the bundler can
 * tree-shake: only what is listed here ships.
 */
const ICONS = {
  'alert-circle': AlertCircle,
  'alert-triangle': AlertTriangle,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'building-2': Building2,
  check: Check,
  'check-circle': CheckCircle2,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'external-link': ExternalLink,
  'file-spreadsheet': FileSpreadsheet,
  info: Info,
  loader: Loader2,
  lock: Lock,
  mail: Mail,
  'map-pin': MapPin,
  phone: Phone,
  plus: Plus,
  'shield-check': ShieldCheck,
  trash: Trash2,
  upload: Upload,
  x: X,
};

export function Icon({ name, size = 20, strokeWidth = 2, color = 'currentColor', style, ...rest }) {
  const Glyph = ICONS[name];

  const box = {
    width: size,
    height: size,
    display: 'inline-block',
    flex: '0 0 auto',
    verticalAlign: 'middle',
    ...style,
  };

  if (!Glyph) {
    if (typeof console !== 'undefined') {
      console.warn(`Icon "${name}" is not in the bundled set. Add it to Icon.jsx.`);
    }
    return <span style={{ ...box, borderRadius: 4, background: 'currentColor', opacity: 0.25 }} {...rest} />;
  }

  return (
    <Glyph
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      style={box}
      aria-hidden="true"
      {...rest}
    />
  );
}

/** Names available without editing this file. */
export const ICON_NAMES = Object.keys(ICONS);
